import { render, staticRenderFns } from "./confirmOrderNew.vue?vue&type=template&id=5fe0560a&scoped=true&"
import script from "./confirmOrderNew.vue?vue&type=script&lang=js&"
export * from "./confirmOrderNew.vue?vue&type=script&lang=js&"
import style0 from "./confirmOrderNew.vue?vue&type=style&index=0&id=5fe0560a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe0560a",
  null
  
)

export default component.exports